/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/experiment.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const ApiRelationship = {
  UNKNOWN_RELATIONSHIP: 'UNKNOWN_RELATIONSHIP',
  OWNER: 'OWNER',
  CREATOR: 'CREATOR',
} as const;
export type ApiRelationship = (typeof ApiRelationship)[keyof typeof ApiRelationship];

export function instanceOfApiRelationship(value: any): boolean {
  for (const key in ApiRelationship) {
    if (Object.prototype.hasOwnProperty.call(ApiRelationship, key)) {
      if (ApiRelationship[key as keyof typeof ApiRelationship] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ApiRelationshipFromJSON(json: any): ApiRelationship {
  return ApiRelationshipFromJSONTyped(json, false);
}

export function ApiRelationshipFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiRelationship {
  return json as ApiRelationship;
}

export function ApiRelationshipToJSON(value?: ApiRelationship | null): any {
  return value as any;
}

export function ApiRelationshipToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ApiRelationship {
  return value as ApiRelationship;
}
